<template>
    <section>
        <v-app-bar color="teal accent-4" fixed class="appBar">
            <v-app-bar-nav-icon
                class="white--text"
                @click.stop="drawer = !drawer"
            />
        </v-app-bar>
        <div
            @mouseenter="['admin', 'acu', 'claims'].includes(userType) ? mini = true : ''"
            @mouseleave="['admin', 'acu', 'claims'].includes(userType) ? mini = false : ''"
        >
            <v-navigation-drawer
                v-model="drawer"
                app
                :mini-variant="mini || !['admin', 'acu', 'claims'].includes(userType) ? false : ''"
                class="navDrawer elevation-5"
                :width="drawerWidth"
                :style="{height: contentHeight + 'px'}"
            >
                <div class="cross">
                    <img :src="require('../assets/white-cross.svg')" alt="Close">
                </div>
                <div v-if="['admin', 'acu', 'claims'].includes(userType)" class="pb-12">
                    <v-list dense class="lists">
                        <v-list-item-group active-class="teal accent-4">
                            <h4 class="pa-3 white--text font-weight-regular">
                                Main
                            </h4>
                            <v-list-item
                                v-for="(item, i) in mergedGuides"
                                :key="i"
                                class="my-4"
                                @click="reload(item.route)"
                            >
                                <v-list-item-icon>
                                    <v-icon class="white--text" v-text="item.icon" />
                                </v-list-item-icon>
                                <v-list-item-content class="white--text">
                                    <v-list-item-title v-text="item.text" />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
                <div v-else-if="userType === 'provider'" class="pb-12">
                    <v-list dense class="lists">
                        <v-list-item-group active-class="teal accent-4">
                            <h4 class="pa-3 white--text font-weight-regular">
                                Main
                            </h4>
                            <v-list-item
                                v-for="(item, i) in guidesProvider"
                                :key="i"
                                class="my-4"
                                style="position: relative;"
                                @click="reload(item.route)"
                            >
                                <v-list-item-icon><v-icon class="white--text" v-text="item.icon" /></v-list-item-icon>
                                <span v-if="item.text === 'Request Patient Diagnostic Procedure'" class="blinking-text">New</span>
                                <v-list-item-content class="white--text" style="margin-left: -8px;">
                                    <v-list-item-title v-text="item.text" />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item :to="privacyRouteProvider">
                                <v-list-item-icon>
                                    <v-icon class="white--text">
                                        {{ mdiShieldOutline }}
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content class="white--text" style="margin-left: -10px;">
                                    <v-list-item-title> Data Privacy Statement</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
                <div v-else-if="userType === 'member'" class="pb-12">
                    <v-list dense class="lists">
                        <v-list-item-group active-class="teal accent-4">
                            <h4 class="pa-3 white--text font-weight-regular">
                                Main
                            </h4>
                            <v-list-item
                                v-for="(item, i) in navList"
                                :key="'nav-' + i"
                                class="my-4"
                                @click="reload(item.route)"
                            >
                                <v-list-item-icon>
                                    <v-icon class="white--text" v-text="item.icon" />
                                </v-list-item-icon>
                                <v-list-item-content class="white--text">
                                    <v-list-item-title v-text="item.text" />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                        <v-list-item-group active-class="teal accent-4">
                            <h4 class="pa-3 white--text font-weight-regular">
                                Others
                            </h4>
                            <!-- Grouped Guidelines -->
                            <v-list-group sub-group value="true">
                                <template #activator>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon class="white--text">
                                                {{ mdiAccount }}
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content class="white--text">
                                            <v-list-item-title>Membership Guidelines</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                                <v-list-item
                                    v-for="(item, i) in guides"
                                    :key="'guide-' + i"
                                    class="my-4"
                                    @click="reload(item.route)"
                                >
                                    <v-list-item-icon>
                                        <v-icon class="white--text" v-text="item.icon" />
                                    </v-list-item-icon>
                                    <v-list-item-content class="white--text">
                                        <v-list-item-title v-text="item.text" />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-group>
                            <!-- Static Items -->
                            <v-list-item :to="faqsroute">
                                <v-list-item-icon>
                                    <v-icon class="white--text">
                                        {{ mdiCommentQuestionOutline }}
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content class="white--text">
                                    <v-list-item-title>FAQs</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item :to="privacyRoute">
                                <v-list-item-icon>
                                    <v-icon class="white--text">
                                        {{ mdiShieldOutline }}
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content class="white--text">
                                    <v-list-item-title>Data Privacy Statement</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
                <p v-show="!isUserLoggedIn">
                    Please <span style="color: blue; text-decoration: underline; font-weight: 600; cursor: pointer;" @click="$router.push('/')">log in</span> to continue ...
                </p>
                <v-bottom-navigation
                    absolute
                    horizontal
                    class="teal accent-4"
                    :input-value="!['admin', 'acu', 'claims'].includes(userType) ? true : mini"
                >
                    <v-btn
                        v-if="userType"
                        width="100%"
                        @click="$router.push(redirectUserManageAccount())"
                    >
                        <span class="white--text">Manage Account</span>
                        <v-icon class="white--text my-1">
                            {{ mdiAccount }}
                        </v-icon>
                    </v-btn>
                    <v-btn width="100%" @click="userLogout">
                        <span class="white--text">Logout</span>
                        <v-icon class="white--text my-1">
                            {{ mdiPower }}
                        </v-icon>
                    </v-btn>
                </v-bottom-navigation>
            </v-navigation-drawer>
        </div>
        <router-view />
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserCookie from 'vue-cookies'
import { 
    mdiInformationVariant, 
    mdiAccountGroup, 
    mdiTools,
    mdiBook,
    mdiMedication,
    mdiHospitalBuilding,
    mdiFountainPenTip,
    mdiBookOpenPageVariant,
    mdiAccountCash,
    mdiCloseOutline,
    mdiMicroscope,
    mdiHospitalBox,
    mdiAccountMultiple,
    mdiHospitalBoxOutline,
    mdiTable,
    mdiNoteTextOutline,
    mdiAccountHeart,
    mdiClipboardTextOutline,
    mdiFlaskEmpty,
    mdiShieldOutline,
    mdiAccount,
    mdiCommentQuestionOutline,
    mdiPower,
    mdiPlusBox,
    mdiStethoscope,
    mdiClipboardTextClock
} from '@mdi/js'
export default {
    data: () => ({
        mdiInformationVariant, 
        mdiAccountGroup, 
        mdiTools,
        mdiBook,
        mdiMedication,
        mdiHospitalBuilding,
        mdiFountainPenTip,
        mdiBookOpenPageVariant,
        mdiAccountCash,
        mdiCloseOutline,
        mdiMicroscope,
        mdiHospitalBox,
        mdiAccountMultiple,
        mdiHospitalBoxOutline,
        mdiTable,
        mdiNoteTextOutline,
        mdiAccountHeart,
        mdiClipboardTextOutline,
        mdiFlaskEmpty,
        mdiShieldOutline,
        mdiAccount,
        mdiCommentQuestionOutline,
        mdiPower,
        mdiPlusBox,
        mdiStethoscope,
        mdiClipboardTextClock,
        drawer: null,
        mini: false, // starts minimized
        isUserLoggedIn: UserCookie.get('user_type') ? true : false,
        session: false,
        faqsroute: '/dashboard/faqs/',
        privacyRoute: '/dashboard/data-privacy',
        privacyRouteProvider: '/provider/data-privacy',
        manageAccountRoute: '/dashboard/manageAccount/',
        guidesAdmin: [
            {
                icon:  mdiInformationVariant,
                text: 'Providers',
                route: '/admin/providers'
            },
            {
                icon: mdiAccountGroup,
                text: 'Members',
                route: '/admin/members'
            },
            {
                icon: mdiTools,
                text: 'Util',
                route: '/admin/util'
            }
        ],
        guidesAcu: [
            {
                icon: mdiAccountHeart,
                text: 'ACU',
                route: '/admin/acu'
            }
        ],
        guidesClaims: [
            {
                icon: mdiBook,
                text: 'Ledgers',
                route: '/admin/claims/ledgers'
            }
        ],
        guidesProvider: [
            {
                icon: mdiInformationVariant,
                text: 'Provider Info',
                route: '/provider/info'
            },
            {
                icon: mdiMedication,
                text: 'Request Patient Consultation',
                route: '/provider/consultation/request/'
            },
            {
                icon: mdiBook,
                text: 'Ledgers',
                route: '/provider/ledger'
            },
            {
                icon: mdiClipboardTextClock,
                text: 'Request History',
                route: '/provider/consultation/history'
            }
        ],
        outpatientRequestsProvider: [
            {
                icon: mdiStethoscope,
                text: 'Consultation',
                route: '/provider/consultation/request/'
            },
            {
                icon: mdiMedication,
                text: 'Outpatient Surgery',
                route: '/provider/surgery/request'
            }
        ],
        guides: [
            {
                icon: mdiHospitalBoxOutline,
                text: 'Availment Procedures',
                route: '/dashboard/availment-proc/'
            },
            {
                icon: mdiHospitalBuilding,
                text: 'Outpatient Request Procedure',
                route: '/dashboard/out-patient-request-proc/'
            },
            {
                icon: mdiFountainPenTip,
                text: 'Definition of terms',
                route: '/dashboard/terms/'
            },
            {
                icon: mdiBookOpenPageVariant,
                text: 'Benefits & Services',
                route: '/dashboard/benefits/'
            },
            {
                icon: mdiAccountCash,
                text: 'Membership Payment/Philhealth Guide',
                route: '/dashboard/fees-ph/'
            },
            {
                icon: mdiInformationVariant,
                text: 'Claims',
                route: '/dashboard/claims/'
            },
            {
                icon: mdiCloseOutline,
                text: 'Exclusions',
                route: '/dashboard/exclusions/'
            }
        ],
        outpatientRequests: [
            {
                icon: mdiStethoscope,
                text: 'Consultation',
                route: '/dashboard/consultation/main'
            },
            {
                icon: mdiMicroscope,
                text: 'Lab & Diagnostic',
                route: '/dashboard/lab-and-diagnostic'
            },
            {
                icon: mdiHospitalBox,
                text: 'Outpatient Surgery',
                route: '/dashboard/outpatient-surgery'
            }
        ],
        navList: [
            {
                icon: mdiInformationVariant,
                text: 'Member Information',
                route: '/dashboard/info/'
            },
            {
                icon: mdiTable,
                text: 'Member Utilizations',
                route: '/dashboard/util/'
            },
            {
                icon: mdiHospitalBoxOutline,
                text: 'Affiliated Facilities/Physicians',
                route: '/dashboard/affiliations/'
            },
            {
                icon: mdiNoteTextOutline,
                text: 'Bills and Benefit Limits',
                route: '/dashboard/bills-limits/'
            },
            {
                icon: mdiPlusBox,
                text: 'Out-Patient Consultation',
                route: '/dashboard/consultation/'
            },
            {
                icon: mdiAccountHeart,
                text: 'Annual Check Up',
                route: '/dashboard/annual-physical-exam'
            }
        ],
        data: false,
        contentHeight: window.innerHeight,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['isSessionExpired', 'hasAcuAccessData', 'hasProcedureAccessData', 'getUserInfo']),
        userType() {
            return this.$cookies.get('user_type')
        },
        mergedGuides() {
            let guides = []

            if (this.userType === 'admin') {
                guides = [...this.guidesAdmin, ...this.guidesAcu, ...this.guidesClaims]
            } else if (this.userType === 'acu') {
                guides = [...this.guidesAcu]
            } else if (this.userType === 'claims') {
                guides = [...this.guidesClaims]
            }

            return guides
        },
        drawerWidth() {
            if (this.userType === 'provider') return 320
            return 320
        }
    },
    watch: {
        screen_width(newVal) {
            if (newVal < 1265) {
                // this.drawer = false
            }
        },
        getUserInfo(newVal) {
            const dependentsRoute = {
                icon: mdiAccountMultiple,
                text: 'Member Dependents',
                route: '/dashboard/dependents'
            }
            if (UserCookie.get('user_type') === 'member') {
                const membType = newVal && newVal.USER_DATA && newVal.USER_DATA.MEMB_TYPE

                if (membType == null) {
                    // Check if the route is already present in navList
                    const routeExists = this.navList.some(item => item.route === dependentsRoute.route)

                    if (!routeExists) {
                        this.navList.splice(1, 0, dependentsRoute)
                    }
                }
            }
        }
    },
    async mounted() {
        window.addEventListener('resize', await this.updateHeight)
        if (this.screen_width < 1265) {
            this.drawer = false
        }
        const acuRoute = {
            icon: mdiAccountHeart,
            text: 'Annual Check Up',
            route: '/provider/annual-check-up'
        }
        const procedureRoute = {
            icon: mdiFlaskEmpty,
            text: 'Diagnostic Procedure',
            route: '/provider/procedure/request/'
        }
        await this.verifyToken()
        if (UserCookie.get('user_type') === 'provider') {
            if (!this.hasAcuAccessData) await this.hasAcuAccess()
            if (this.hasAcuAccessData && this.hasAcuAccessData.data) {
                this.guidesProvider.splice(2, 0, acuRoute)
            }
            if (!this.hasProcedureAccessData) await this.hasProcedureAccess()
            if (this.hasProcedureAccessData && this.hasProcedureAccessData.data) {
                this.guidesProvider.splice(2, 0, procedureRoute)
            }
        }
        if (this.getUserInfo == null && this.$cookies.get('usermembn')) {
            await this.userInfo({ MEMBN: this.$cookies.get('usermembn') })
        }
    },
    async beforeDestroy() {
        window.removeEventListener('resize', await this.updateHeight)
    },
    methods: {
        ...mapActions(['userLogout', 'verifyToken', 'hasAcuAccess', 'hasProcedureAccess', 'userInfo']),
        redirectUserManageAccount() {
            if (UserCookie.get('user_type') === 'admin' || UserCookie.get('user_type') === 'claims' || UserCookie.get('user_type') === 'acu') {
                return '/admin/manageaccount'
            } else if (UserCookie.get('user_type') === 'provider') {
                return '/provider/manageaccount'
            } else {
                return this.manageAccountRoute
            }
        },
        showSession(session) {
            this.session = session
        },
        async updateHeight() {
            this.contentHeight = window.innerHeight
            this.screen_width = document.documentElement.clientWidth
        },
        async reload(route) {
            // Check if the target route matches the current active route
            if (this.$route.path === route) {
                if (this.screen_width < 1264) this.drawer = false
                return // Already on this page, do nothing
            }

            await this.verifyToken()
            this.$router.push(route).catch(err => {
                // Suppress NavigationDuplicated error if triggered elsewhere
                if (err.name !== 'NavigationDuplicated') {
                    throw err
                }
            })
        }
    }
}
</script>

<style scoped>
/* Fix expansion arrow icon container alignment */
::v-deep .custom-list-group .v-list-group__header {
  padding-left: 16px !important;
}

/* Align arrow icon with normal list icons */
::v-deep .custom-list-group .v-list-group__header .v-list-group__header__append-icon {
  min-width: 24px !important;
  margin-right: 16px !important;
  margin-left: 0 !important;
  order: -1; /* Places arrow on the left side */
  justify-content: center;
}

/* Position sub-item left border to align under the arrow */
.sub-nav-border {
  border-left: 2px solid rgba(255, 255, 255, 0.3);
  margin-left: 27px; /* Align vertically under center of arrow icon */
  padding-left: 8px;
}

.sub-item {
  min-height: 38px !important;
}
@keyframes pulse {
  0% { transform: scale(.9); opacity: 1; }
  50% { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(.9); opacity: 1; }
}

.blinking-text {
  position: absolute;
  right: 10px;
  font-size: 11px;
  font-weight: bold;
  color: #333; /* Dark text for contrast */
  background: #FFC107; /* Bright Yellow */
  padding: 3px 7px;
  border-radius: 6px;
  text-transform: uppercase;
  display: inline-block;
  animation: pulse 2s infinite;
}

section {
  height: 100%;
}
.appBar {
  display: none;
}
.navDrawer {
  background-image: url("../assets/drawer.svg");
  background-position: center;
  background-size: cover;
}

.navDrawer {
  width: 280px;
}

.cross {
  width: 60%;
  margin: 20px auto;
}
.cross img {
  width: 100%;
}
@media (max-width: 599px) {
  .appBar {
    display: block;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .appBar {
    display: block;
  }
}
</style>
